import React, { Component } from 'react'
import { translate } from 'react-polyglot'
import classNames from 'classnames'

import Icon from 'components/Icon'

class SuggestionItem extends Component {
	onClick = () => {
		const { execute, suggestion } = this.props

		execute(suggestion)
	}

	onMouseEnter = () => {
		const { setSelectedIndex, index } = this.props

		setSelectedIndex(index)
	}

	render = () => {
		const { index, selectedIndex, suggestion, className, t } = this.props

		const itemClasses = classNames(
			className,
			index === selectedIndex ? 'is-selected' : undefined
		)

		return (
			<div
				className={itemClasses}
				onClick={this.onClick}
				onMouseEnter={this.onMouseEnter}
			>
				{suggestion.suggestion.icon && (
					<div className="c-suggestions__icon">
						<Icon name={suggestion.suggestion.icon.name} />
					</div>
				)}
				{suggestion.suggestion.image && (
					<div className="c-suggestions__image">
						<img
							src={`/assets/img/${suggestion.suggestion.image.name}`}
							alt=""
						/>
					</div>
				)}
				<div className="c-suggestions__title">
					{t(`suggestions.${suggestion.key}`)}
				</div>
				{suggestion.suggestion.meta && (
					<div className="c-suggestions__meta">
						{suggestion.suggestion.meta}
					</div>
				)}
			</div>
		)
	}
}

export default translate()(SuggestionItem)
